import React from 'react'

interface ErrorModalProps {
  isOpen: boolean
  message?: string
  onClose: () => void
}

/**
 * Reusable error modal component for displaying error messages
 * Can be used across the entire application
 */
const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null

  // Never render a blank modal — if handed an empty/whitespace message, show a
  // useful fallback with a way to reach us.
  const displayMessage = message && message.trim()
    ? message
    : 'Something went wrong. Please try again — if it keeps happening, call us at (614) 699-2495 and we’ll get you set up.'

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{
          color: '#e74c3c',
          marginTop: 0,
          marginBottom: '1rem',
          fontSize: '1.5rem',
          fontWeight: 'bold'
        }}>
          Error
        </h2>
        <p style={{
          color: '#333',
          marginBottom: '1.5rem',
          lineHeight: '1.5',
          whiteSpace: 'pre-wrap'
        }}>
          {displayMessage}
        </p>
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={onClose}
            style={{
              background: '#232043',
              color: 'yellow',
              border: 'none',
              padding: '0.75rem 2rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 700,
              letterSpacing: 1.2,
              fontSize: '1rem',
              fontFamily: 'Exo'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorModal
